import { SvgIconProps } from './icon-props';

export default function Activities({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg
			viewBox="0 0 32 32"
			version="1.2"
			baseProfile="tiny-ps"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
		>
			<path
				fillRule="evenodd"
				d="M15.5 14.3V3.5c0-.3.2-.5.5-.5h.3l7 3.4c.4.2.4.7 0 .9l-6.8 3.5v3.6c7.5.1 13.5 3.1 13.5 7.1 0 4-6.3 7.2-14 7.2S2 25.6 2 21.5c0-4 6-7 13.5-7.2zm1 1v4.2c1.7.1 2.9.5 2.9 1.4 0 .9-1.5 1.4-3.4 1.4s-3.4-.5-3.4-1.4c0-.8 1.3-1.3 2.9-1.4v-4.2C8.5 15.4 3 18.2 3 21.5c0 3.3 5.8 6.2 13 6.2s13-2.9 13-6.2c0-3.3-5.5-6.1-12.5-6.2zm6.6 7.1c-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6 0 .9-.8 1.6-1.6 1.6zm-7.6-1.2v-.7c-1.1.1-2 .4-2 .4s.9.3 2 .3zm1-.6v.7c1.1-.1 2-.4 2-.4 0-.1-.9-.3-2-.3zm6.6.8c.3 0 .6-.3.6-.6s-.3-.6-.6-.6-.6.3-.6.6.2.6.6.6zM21.9 6.9l-5.5-2.6v5.4l5.5-2.8z"
			/>
		</svg>
	);
}
